import React, {Component} from "react";
import Prototypes from 'prop-types'
import MediatorEntryForm from "./MediatorEntryForm";
import {adminApi} from "../../services/ApiService";
import {makeError} from "../modals/ErrorModal";
import {sendMessage} from "../modals/MessageModal";
import {authenticationService} from "../../services/AuthenticationService";


class MediatorsTabTools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterHcpTable:'',
            searchValue: '',
            isSideBarOpen: false,
        };
    }

    componentDidMount() {
    }

    filterHcpTable(val){
        this.setState({searchValue:val})
        this.props.filterHcpTable(val)
    }

    openSideBar(){
        document.body.style.overflow = "hidden"
        this.setState({isSideBarOpen:true})
    }

    sendMessage = async () => {
        let {t} = this.props
        if (this.props.recipients.length > 0){
            let Method = await sendMessage({
            },this.props.recipients);
            if (Method){
                let DoctorsIDs = this.props.recipients.map(user =>{
                    return user.id
                })
                await adminApi.sendMessageToHcp({Method,DoctorsIDs})
            }
        } else {
            await makeError({
                proceedLabel: t('admin.mediator.ok'),
                options:{
                    title: t('admin.mediator.could_not_opn_msg'),
                }
            },[t('admin.mediator.select_recipients')]);
        }
    }

    render() {
        let {t} = this.props
        let {isSideBarOpen} = this.state
        let current  = authenticationService.currentUserValue
        let TabTools_Size ='Admin-TabTools'
        return (
            <div className={`${TabTools_Size} custom-control`}>
                <div className={"TabTools-container"}>
                    <div className={"button-wrapper"}>
                        <button type={"button"} onClick={this.openSideBar.bind(this)} className={"btn btn-primary "}>+ {t('admin.mediator.add_new')}</button>
                    </div>
                </div>
                {isSideBarOpen && !current?.profile?.Doctor?.isClinicAdmin && <MediatorEntryForm
                    t={e => t(e)}
                    title={t('admin.mediator.add_new')}
                    isSideBarOpen={isSideBarOpen}
                    addMediatorData={mediator => this.props.addMediatorData(mediator)}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}
            </div>
        );
    }
}

MediatorsTabTools.Prototypes = {
    filterHcpTable: Prototypes.func.isRequired,
    addMediatorData: Prototypes.func.isRequired,
}

export default MediatorsTabTools

